var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('users-widget',{key:(_vm.orgRef + "-board-" + _vm.boardRef + "-users"),attrs:{"boardRef":_vm.boardRef,"org-ref":_vm.orgRef,"dismiss":_vm.dismiss}})}
var staticRenderFns = []

export { render, staticRenderFns }